import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = {
  ref: "wrapperRef",
  class: "wrap-input validate-input"
}
const _hoisted_3 = ["id", "value", "type", "placeholder", "disabled", "readonly", "enterkeyhint"]
const _hoisted_4 = ["disabled", "tabindex", "aria-label"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("section", null, [
    (_ctx.isLabel)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          class: "label",
          for: _ctx.id
        }, _toDisplayString(_ctx.t(_ctx.label)), 9, _hoisted_1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("input", {
        id: _ctx.id,
        ref: "inputRef",
        value: _ctx.modelValue,
        class: _normalizeClass(["input100", { pr: _ctx.icon, error: _ctx.error }]),
        type: _ctx.type,
        placeholder: _ctx.t(_ctx.placeholder),
        disabled: _ctx.disabled,
        readonly: _ctx.readonly,
        style: _normalizeStyle({ height: _ctx.height, cursor: _ctx.cursor }),
        enterkeyhint: _ctx.submitOnSearch ? 'search' : undefined,
        onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
        onKeydown: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.handleEnter && _ctx.handleEnter(...args)), ["enter"])),
        onBlur: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleBlur && _ctx.handleBlur(...args))),
        onFocus: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.showErrorToggle && _ctx.showErrorToggle(...args)))
      }, null, 46, _hoisted_3),
      _cache[5] || (_cache[5] = _createElementVNode("span", { class: "focus-input100" }, null, -1)),
      (_ctx.icon)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: _normalizeClass(["symbol-input100", { clickable: _ctx.submitOnSearch }]),
            disabled: _ctx.disabled || !_ctx.submitOnSearch,
            tabindex: _ctx.submitOnSearch ? 0 : -1,
            "aria-label": _ctx.submitOnSearch ? _ctx.t(_ctx.placeholder || 'search') : undefined,
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleIconClick && _ctx.handleIconClick(...args)))
          }, [
            _createVNode(_component_font_awesome_icon, { icon: _ctx.icon }, null, 8, ["icon"])
          ], 10, _hoisted_4))
        : _createCommentVNode("", true)
    ], 512)
  ]))
}